<template>
  <Hero :title="data?.header.title" :subtitle="data?.header.subtitle" :images="data?.header.images"/>
  <div class="overhanging--sm maxw--neck">
    <div class="card text--center" v-html="$md.render(data?.intro || '')">
    </div>
  </div>
  <main class="main maxw--shoulders">
    <div class="block grid--five">
      <ManagementItem v-for="member in members" :key="member.id" :data="member"/>
    </div>
  </main>
</template>

<script lang="ts" setup>
import ManagementMember from '~/typings/management_member';
import ManagamentPage from '~/typings/pages/management_page';

useHead({
  title: 'Bestuur'
});

const { findOne, find } = useStrapi();

const { data } = await useAsyncData(
  'managementpage',
  () => findOne<ManagamentPage>('management-page', { populate: ['header', 'header.images'] }),
  {
    transform: flattenStrapiObject
  }
);

const { data: members } = await useAsyncData(
  'managementmembers',
  () => find<ManagementMember>('management-members', { populate: ['image'] }),
  {
    transform: flattenStrapiCollection
  }
);
</script>
